import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SidenavService } from '../../sidenav/sidenav.service';
import { PlatformGlobalService } from '../../service/platform-global.service';
import { DashboardService } from 'src/app/pages/dashboard/service/dashboard.service';

import { LanguageSelectorModel } from 'src/@prep/shared/language-selector/model/language-selector.model';
import { LanguageSelectorService } from 'src/@prep/shared/language-selector/service/language-selector.service';
import { TopToolbarTextDataEN } from '../toolbar-multi-lang/en-US';
import { TopToolbarTextDataES } from '../toolbar-multi-lang/es-EU';
import { TopToolbarTextDataIT } from '../toolbar-multi-lang/it-IT';

@Component({
  selector: 'prep-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  styleUrls: ['./toolbar-user.component.scss'],
})
export class ToolbarUserComponent implements OnInit {
  isOpen: boolean;
  currentFocusIndex = 0;
  menuItems: HTMLElement[];

  selectedLang: LanguageSelectorModel =
    this.languageSelectorService.getCurrentLanguage();
  LangTextData: any;
  constructor(
    private router: Router,
    private platformGlobalService: PlatformGlobalService,
    private dashboardService: DashboardService,
    private sidenavService: SidenavService,
    private languageSelectorService: LanguageSelectorService
  ) {
    this.languageSelectorService.language$.subscribe((lang) => {
      this.selectedLang = lang;
      console.log(
        '🌍 Language changed:',
        lang,
        lang.code,
        this.selectedLang.code
      );
      switch (this.selectedLang.code) {
        case 'en': {
          this.LangTextData = TopToolbarTextDataEN;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'es': {
          this.LangTextData = TopToolbarTextDataES;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'it': {
          this.LangTextData = TopToolbarTextDataIT;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        default: {
          this.LangTextData = TopToolbarTextDataEN;
          console.log('🌍 Default Language:', this.LangTextData);
          break;
        }
      }
    });
  }

  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.isOpen) {
      this.closeDropdown();
    }
  }


  ngOnInit() { }

  toggleDropdown() {
    this.isOpen = !this.isOpen;

    if (this.isOpen) {
      const button = document.getElementById('user-menu-button');

      if (button) {
        // Step 1: focus the button so NVDA announces "expanded"
        button.focus();
      }

      // Step 2: allow NVDA to finish speaking "expanded"
      setTimeout(() => {
        this.menuItems = Array.from(
          document.querySelectorAll('#user-menu [role="menuitem"]')
        );

        this.currentFocusIndex = 0;

        // Step 3: THEN move focus to first menu item
        this.menuItems[0].focus();
      }, 250);  // <-- This delay is REQUIRED for NVDA to read "expanded"
    }
  }



  onClickOutside() {
    this.isOpen = false;
  }

  logoutClicked() {
    console.log('User Info toolbar', this.platformGlobalService.getCUserinfo);
    if (this.platformGlobalService.getCUserinfo.email) {
      let sendUserInfo = {
        username: this.platformGlobalService.getCUserinfo.email,
      };
      this.dashboardService.logoutCuncurrentUser(sendUserInfo).subscribe(
        (response) => {
          if (response.msg) {
            localStorage.removeItem('token');
            localStorage.removeItem('account');
            this.sidenavService.items = [];
            this.router.navigate(['/login']);
          }
        },
        (error) => {
          console.log('error', error);
          localStorage.removeItem('token');
          localStorage.removeItem('account');
          this.sidenavService.items = [];
          this.router.navigate(['/login']);
        }
      );
    }
    // localStorage.removeItem('token');
    // localStorage.removeItem('account');
    // this.sidenavService.items = [];
    // this.router.navigate(['/login']);
  }
  profile() {
    console.log('welcome to profile');
    this.router.navigate(['/profile']);
  }

  // Called on Escape key press
  closeDropdown() {
    // 1. Update aria-expanded BEFORE moving focus
    this.isOpen = false;

    // 2. Put focus back on button AFTER attribute is updated
    setTimeout(() => {
      const button = document.getElementById('user-menu-button');
      if (button) {
        button.focus();
      }
    }, 0);
  }

  // Called when focus leaves the dropdown menu
  onFocusOut(event: FocusEvent) {
    const relatedTarget = event.relatedTarget as HTMLElement;
    const menu = document.getElementById('user-menu');

    if (menu && relatedTarget && !menu.contains(relatedTarget)) {
      this.isOpen = false;    // Update state first
    }
  }


  onArrowDown(event: KeyboardEvent) {
    event.preventDefault();
    this.currentFocusIndex = Math.min(this.currentFocusIndex + 1, this.menuItems.length - 1);
    this.menuItems[this.currentFocusIndex].focus();
  }

  // onArrowUp(event: KeyboardEvent) {
  //   event.preventDefault();
  //   this.currentFocusIndex = Math.max(this.currentFocusIndex - 1, 0);
  //   this.menuItems[this.currentFocusIndex].focus();
  // }

  onArrowUp(event: KeyboardEvent) {
  event.preventDefault();

  // If user is on the first menu item and presses Up arrow → move focus back to parent button
  if (this.currentFocusIndex === 0) {
    const button = document.getElementById('user-menu-button');
    if (button) {
      button.focus();
    }
    return;
  }

  // Otherwise move focus normally
  this.currentFocusIndex = Math.max(this.currentFocusIndex - 1, 0);
  this.menuItems[this.currentFocusIndex].focus();
}

}
